export default __webpack_public_path__ + "static/bariol_serif_regular_italic-webfont-727e3ecf0c20daf4adb112a299156ba2.ttf";